/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {DecoratorDownlevelCompilerHost, MetadataWriterHost} from './src/compiler_host';
export {CodegenExtension, UserError, main} from './src/main';

export {default as AngularCompilerOptions} from './src/options';
export * from './src/cli_options';
export * from './src/collector';
export * from './src/schema';
